import md5 from 'md5';

export function isTokenValid(participantId, envelopeId, token) {
    if (!participantId || !envelopeId || !token) return false;
    const expected = generateToken(participantId, envelopeId);
    return token === expected;
}

/**
 * Gera o token de acesso para o experimento.
 * @param {string|number} participantId
 * @param {string|number} envelopeId
 * @returns {string} token
 */
export function generateToken(participantId, envelopeId) {
    if (!participantId || !envelopeId) return '';
    const calc = Math.pow((Number(envelopeId) * Number(participantId) + 5), 2);
    return md5(String(calc));
}
